export const TermsConditions = () => (
	<div className="policy-container">
		<h1>Terms & Conditions</h1>
		<p>By using our platform, you agree to the following terms of service:</p>
		<ul>
			<li><strong>Service Platform:</strong> We connect users with third-party providers. The final contract is between the user and the provider.</li>
			<li><strong>User Conduct:</strong> Users must provide accurate Name, Phone, and Location.</li>
			<li><strong>Liability:</strong> MyBharatService is not liable for any loss arising from the conduct of independent providers.</li>
			<li>
				<strong>Messaging Services:</strong><br />
				<strong>MyBharatService</strong> (operated by <strong>CITIKART ONLINE SERVICE PRIVATE LIMITED</strong>) uses WhatsApp to provide real-time updates.<br /><br />
				By using our platform, you consent to receive these automated messages (including OTPs and lead notifications). Standard data rates from your mobile carrier may apply.<br /><br />
				We are not responsible for any delays in message delivery caused by carrier network issues, device-level restrictions, or <strong>Meta’s platform availability</strong>.
			</li>
		</ul>
		{/* Footer for Legal Connection */}
		<footer style={{ marginTop: '30px', borderTop: '1px solid #ddd', paddingTop: '10px', fontSize: '0.85rem' }}>
			<p>MyBharatService is a registered brand name of <strong>CITIKART ONLINE SERVICE PRIVATE LIMITED</strong>. All rights reserved.</p>
		</footer>
	</div>
);
